// src/components/MainLayout.tsx
import React, { Suspense } from 'react';
import Header from './Header';
import Footer from './Footer';
import { Outlet } from 'react-router-dom';

const MainLayout: React.FC = () => {
  return (
    <div className="flex min-h-screen flex-col bg-surface-muted">
      <Header />
      <div className="flex-1">
        {/* Pages load on demand; keep the header and footer showing meanwhile. */}
        <Suspense
          fallback={
            <div className="flex min-h-[60vh] items-center justify-center" role="status" aria-label="Loading">
              <div className="h-8 w-8 animate-spin rounded-full border-4 border-surface-subtle border-t-brand-500" />
            </div>
          }
        >
          <Outlet />
        </Suspense>
      </div>
      <Footer />
    </div>
  );
};

export default MainLayout;
